<!--  no need for this for now 

@click="pageclick"
@getPagePoint="currentpage"
@_getVisiblePages="currentpage"
@mousescroll="currentpage"
@hover="currentpage"
@getPageView="whatpage"
:pagechanging="whatpage"
@pagenumberchanged="whatpage"
@_scrollIntoView="whatpage"
@scrollPageIntoView="whatpage"
@focus="whatpage"
@on="page"
@open="openHandler"
@pages-rendered="pagesRenderedHandler"
:page-number="page"
@scrollPageIntoView="whatpage"
:click="showcontract()"
:click="whatpage()"
@getPageView="whatpage()"
:mouseup="whatpage()"
-->
<!--  https://xd.adobe.com/view/043c2377-c87d-41bf-b429-2ffe2322e7ce-516f/specs/ 
https://docs.google.com/presentation/d/1UivJFMHQGhHTr5JY2Nq057cU3yz4bjN19aF1Y7TOsnw/edit#slide=id.g13fb061f812_3_1
https://docs.google.com/presentation/d/13UsZSW6pwkxbykyikLyZZ6SMvyENk4zDX6HOSUztTt4/edit#
-->
<template>
  <div id="contract-main" class="clearfix noto-sans darkblue px2 mb4">
    <div class="col-12">
          <div class="clearfix ">
            <div class="col-12 mt2 px0 flex justify-between items-center">
                <p class="h1 regular line-height-2 my3 ">UDKAST KONTRAKT</p>
            </div>
            <div v-if="loading">
              <div class="col-12">
                <div class="loader"></div>
              </div>
            </div>
            <div v-else>
              <p class=" darkblue font14 col-12 m0 p0">Fremhæv den tekst, du vil kommentere</p>
              <div class="flex flex-row mobile-flex-column col-12 m0 pb2 p0 commentdiv" style="gap:10px">
                <div class="highlights border md-col-9 lg-col-9 xs-col-12 mp0 overflow-auto ">
                  <div class="py1 col-12 p0 relative" style="height:95%;overflow:auto;" >
                    <vue-pdf-app :pdf="contractpdflink"  @pages-rendered="pagesRenderedHandler" class="pointer"></vue-pdf-app>
                  </div>
                </div>
                <div class="highlights border lg-col-3 md-col-3 xs-col-12 p2 commentdiv ">
                  <el-tabs v-model="activeName">
                    <el-tab-pane label="Bekræft kontrakt" name="Confirm">
                      <div class="flex p2">
                        <button type="button" @click="confirmcontract()" class="action-button not-rounded mx-auto flex col-lg-12 col-md-12 col-sm-12 p1 mt2 justify-center items-center">
                          <span class="font14 m0 semi-bold">UNDERSKREVET<i class="el-icon-right"></i></span>
                        </button>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="Kommentarhåndtering" name="Comment">
                    <div v-if="commentmanagementloading">
                      <div class="col-12">
                        <div class="loader"></div>
                      </div>
                    </div>
                    <div class="flex flex-column m0 p0" v-else>
                      <div class="h5 p2 center mt3" v-if="comments.length < 1">For at kommentere, klik venligst på den side, hvor du vil kommentere</div>
                      <div class="h6 border p2 darkblue flex flex-column" v-for="(comment,index) in filteredcomments" :key="comment.id">
                          <div class="flex col-12 m0 p0">
                          <p class="mr-auto font14 regular m0" v-if="comment.fromdb">Comment on Page {{comment.PAGE}}</p>
                          <p class="mr-auto font14 regularm0" v-else>New Comment on Page {{comment.PAGE}}</p>
                          <p :class="comment.STATUS === 'Approved' ? 'green ml-auto font14 semi-bold m0' : 'primarycolor ml-auto font14 m0 semi-bold'">{{comment.STATUS}}</p>
                          </div>
                          <div class="flex justify-center items-center pt2 col-12 p0 m0" v-if="comment.HIGHLIGHTED_TEXT !== '' && comment.HIGHLIGHTED_TEXT !== null"><p class="primarycolor">"{{comment.HIGHLIGHTED_TEXT}}"</p></div>
                          <el-input :disabled="comment.fromdb" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="Pls specify the section no" v-model="textarea[index]"></el-input>
                          <!-- <p class="font12 regular flex justify-start pt1 m0">Step {{comment.UF_TITLE}}</p> -->
                          <div class="col-12 p0 m0 flex mt1 mx-auto " >
                            <button @click="deletecommentarray(comment)" v-if="!comment.fromdb" type="button" class="primary-button mr-auto not-rounded flex col-lg-5 col-md-5 col-sm-5 p1 justify-center items-center">
                              <span class="font12 m0"><i class="el-icon-back"> Afbestille</i></span>
                            </button>
                            <button @click="deletecomment(comment)" v-else type="button" class="primary-button mr-auto not-rounded flex col-lg-5 col-md-5 col-sm-5 p1 justify-center items-center">
                              <span class="font12 m0"><i class="el-icon-back"> Skjule</i></span>
                            </button>
                            <button @click="saveComment(comment,index)" v-if="!comment.fromdb" type="button"  class="ml-auto action-button not-rounded flex col-lg-5 col-md-5 col-sm-5 p1 justify-center items-center">
                              <span class="font12 m0">Submit<i class="el-icon-right"></i></span>
                            </button>
                          </div>
                      </div>
                    </div>
                    </el-tab-pane>
                  </el-tabs>
                  <div class="py3 sm-hide lg-hide md-hide"></div>
                </div>
              </div>
                <div class="py3"></div>
            </div>
          </div>
      </div>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import VuePdfApp from 'vue-pdf-app'
import Simplert from 'vue2-simplert'
export default {
  name: 'contract-mainv2',
  components: {
    VuePdfApp,
    Simplert
  },
  data () {
    return {
      contractID: 11,
      contractStatus: '',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      homeownerID: 3130899,
      haaId: localStorage.getItem('haaid'),
      salesPersonbitrix: localStorage.getItem('id_token_portalbitrix'),
      loading: false,
      showMobile: false,
      info: [],
      pdf: [],
      page: 1,
      historypage: '',
      comments: [],
      textarea: [],
      activeName: 'Comment',
      loaded: 1,
      activepage: 0,
      filteredcomments: [],
      commentmanagementloading: true,
      stepsarr: []
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
    this.historypage = localStorage.getItem('pdfjs.history')
    this.getProjectDetails()
  },
  mounted () {
  },
  watch: {
    // 'pdf': function (newVal, oldVal) {
    //   console.log('watchpage2', newVal)
    //   newVal.bindEvents('pagechanging', this.search2())
    // }
    'pdf.page': function (newVal, oldVal) {
      this.activepage = newVal
      setTimeout(() => {
        this.filtercommentsbyId(newVal)
      }, 200)
    }
    // 'currentpage': function (newVal, oldVal) {
    //   console.log('watchpage', newVal)
    // },
    // 'page': function (newVal, oldVal) {
    //   console.log('pagepage', newVal)
    // }
    // 'historypage': function (newVal, oldVal) {
    //   this.historypage = localStorage.getItem('pdfjs.history')
    //   console.log('pagehistory', this.historypage)
    // }
  },
  methods: {
    showcontract () {
      var searchInput = document.querySelectorAll('[data-page-number]')
      var searchinputpage = []
      var thisthisvarvar = this
      searchInput.forEach((a) => {
        if (a.className === 'page') {
          searchinputpage.push(a)
        }
      })
      searchinputpage.forEach((a, index) => {
        if (a.className === 'page') {
          a.addEventListener('mouseup', () => {
            var text = window.getSelection().toString()
            if (text !== '') {
              thisthisvarvar.addComment(index + 1, text)
            }
          })
        }
      })
    },
    getContract () {
      var projectid = this.$route.query.projectId
      var latestproject = []
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contracts', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            latestproject = res.data.CONTRACTS.filter(function (a) {
              return a.PROJECT.ID === parseInt(projectid)
            })
            this.contractdetails = latestproject[latestproject.length - 1]
            this.contractID = this.contractdetails.ID
            this.contractpdflink = '/static/pdf/sample.pdf'
            this.homeownerID = this.contractdetails.CONTACT
            this.getContractComments()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        response => {
          // this.$message({
          //   type: 'error',
          //   message: response.body.message
          // })
          this.getContract()
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getContract()
            }, 1000)
          }
        })
    },
    getProjectDetails () {
      var projectid = this.$route.query.projectId
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.contractID = res.data.CONTRACT_ID
            this.contractStatus = res.data.CONTRACT_STATUS
            this.homeownerID = res.data.HOMEOWNER.ID
            this.getContractByProjectId()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
            this.loading = false
          }
        },
        response => {
          this.loading = false
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getProjectDetails()
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        })
    },
    getContractByProjectId () {
      this.commentmanagementloading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.contractdetails = res.data
            this.comments = res.data.COMMENTS.reverse()
            this.contractID = this.contractdetails.ID
            this.contractpdflink = '/static/pdf/sample.pdf'
            var thisvar = this
            res.data.COMMENTS.forEach((a, index) => {
              thisvar.comments[index]['fromdb'] = true
              thisvar.textarea[index] = a.COMMENTS
            })
            if (this.loaded === 1) {
              setTimeout(() => {
                this.showcontract()
              }, 3000)
            }
            this.loaded = 2
            this.filtercommentsbyId(this.activepage)
            this.loading = false
            this.commentmanagementloading = false
            this.getContractSteps()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
            this.loading = false
          }
        },
        response => {
          this.loading = false
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getContractByProjectId()
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        })
    },
    getContractComments () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract/comments/' + this.contractID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.comments = res.data.reverse()
            var thisvar = this
            this.comments.forEach((a, index) => {
              thisvar.comments[index]['fromdb'] = true
              thisvar.textarea[index] = a.COMMENTS
            })
            if (this.loaded === 1) {
              setTimeout(() => {
                this.showcontract()
              }, 5000)
            }
            this.loaded = 2
            this.loading = false
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
            this.loading = false
          }
        },
        response => {
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getContractComments()
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          }
        })
    },
    getContractSteps () {
      // if field 0, they can't edit
      var documents = []
      var steps = []
      var stepsvalue = []
      documents = this.contractdetails.DOCUMENTS[this.contractdetails.DOCUMENTS.length - 1]
      steps = documents.JSON_STEPS
      var arrsteps = Object.entries(steps)
      arrsteps.forEach(a => {
        var arrfield = Object.entries(a)
        arrfield[arrfield.length - 1].forEach(h => {
          if (typeof h === 'object') {
            h['fields'].forEach(n => {
              if (n.field !== 0) {
                var tempvalue = {
                  key: h.key,
                  value: n.default_value
                }
                stepsvalue.push(tempvalue)
                tempvalue = []
              }
            })
          }
        })
      })
      // for (var step in steps) {
      //   for (var field in steps[step]) {
      //     for (var val in field['fields']) {
      //       console.log('val', val)
      //       if (field.field !== 0) {
      //         var tempvalue = {
      //           key: field.key,
      //           value: field.default_value
      //         }
      //         stepsvalue.push(tempvalue)
      //       }
      //     }
      //   }
      // }
      this.stepsarr = stepsvalue
    },
    getStepbycontent (content) {
      this.stepsarr.forEach(l => {
        if (l.value.toString().includes(content)) {
          return l
        } else {
          return false
        }
      })
    },
    saveComment (item, index) {
      var step = item.TITLE
      var page = item.PAGE
      var highlighttext = item.HIGHLIGHTED_TEXT
      var desccomment = this.textarea[index]
      this.$confirm('Er du sikker på, at du vil gemme denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
        }
        this.$http.post(this.$bitrixapi + 'partner/contract/comments?contractId=' + this.contractID + '&title=' + step + '&comments=' + desccomment + '&page=' + page + '&highlightedText=' + highlighttext + '&contactId=' + this.homeownerID, data, { headers }, { emulateJSON: true })
          .then(
            response => {
              if (response.body.success) {
                let obj = {
                  title: 'Gennemført!',
                  message: 'Success',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
              }
              this.getContractByProjectId()
            },
            err => {
              this.$message({
                type: 'error',
                message: err.body.message
              })
            }
          )
      }).catch(() => {
      })
    },
    addComment (page, selectedtext, step = 1) {
      var haaid = localStorage.getItem('haaid')
      var stepno = this.getStepbycontent(selectedtext)
      if (stepno) {
        step = stepno.key
      }
      var commentdetails = {
        'HIGHLIGHTED_TEXT': selectedtext,
        'COMMENTS': '',
        'PAGE': page,
        'TITLE': step,
        'STATUS': 'pending',
        'CONTRACT_ID': this.contractID,
        'CONTACT_ID': this.homeownerID,
        'COMPANY_ID': haaid,
        'fromdb': false
      }
      this.comments.unshift(commentdetails)
      this.filteredcomments.unshift(commentdetails)
      var thisvar = this
      this.comments.forEach((a, index) => {
        thisvar.comments[index]['fromdb'] = a.fromdb
        thisvar.textarea[index] = a.COMMENTS
      })
      this.filteredcomments.forEach((b, index) => {
        thisvar.filteredcomments[index]['fromdb'] = b.fromdb
        thisvar.textarea[index] = b.COMMENTS
      })
      commentdetails = []
    },
    confirmcontract () {
      this.$confirm('Er du sikker på, at du vil synge denne kontrakt', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        // var headers = {
        //   Authorization: 'Bearer ' + this.salesPersonbitrix
        // }
        // var data = {
        // }
        // this.$http.post(this.$bitrixapi + 'partner/contract/' + this.contractID + '/approve?messageId=1&fileId=1', data, { headers }, { emulateJSON: true })
        //   .then(
        //     response => {
        //       if (response.body.success) {
        //         let obj = {
        //           title: 'Gennemført!',
        //           message: 'Success',
        //           type: 'success',
        //           customCloseBtnText: 'Luk'
        //         }
        //         this.$refs.simplert.openSimplert(obj)
        //       }
        //     },
        //     err => {
        //       this.$message({
        //         type: 'error',
        //         message: err.body.message
        //       })
        //     }
        //   )
        this.loading = true
        setTimeout(() => {
          let obj = {
            title: 'Gennemført!',
            message: 'Success',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          this.loading = false
          setTimeout(() => {
            this.$router.push('/customer-projects/project-dashboard')
          }, 2000)
        }, 2000)
      }).catch(() => {
      })
    },
    deletecommentarray (item) {
      this.comments.splice(this.comments.indexOf(item), 1)
      this.textarea.splice(this.textarea.indexOf(item.COMMENTS), 1)
      this.getContractByProjectId()
    },
    deletecomment (item) {
      this.$confirm('Er du sikker på, at du vil slette denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(() => {
        this.commentmanagementloading = true
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {
        }
        this.$http.post(this.$bitrixapi + 'partner/contract/comments/' + item.ID + '/delete', data, { headers }, { emulateJSON: true })
          .then(
            response => {
              if (response.body.success) {
                let obj = {
                  title: 'Gennemført!',
                  message: 'Success',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                }
                this.$refs.simplert.openSimplert(obj)
                this.getContractByProjectId()
              }
            },
            err => {
              this.$message({
                type: 'error',
                message: err.body.message
              })
            }
          )
      }).catch(() => {
      })
    },
    // when change of page is triggered, this will run
    filtercommentsbyId (page) {
      var filtered = []
      var thisthisvar = this
      filtered = this.comments.filter(a => {
        return a.PAGE === page
      })
      filtered.forEach((b, index) => {
        if (b.HIGHLIGHTED_TEXT !== null && b.HIGHLIGHTED_TEXT !== '') {
          thisthisvar.hightlighttext(b.HIGHLIGHTED_TEXT)
        }
        thisthisvar.textarea[index] = b.COMMENTS
      })
      this.filteredcomments = filtered
    },
    hightlighttext (text) {
      var textactula = document.querySelectorAll('[data-page-number="' + this.activepage + '"] > .textLayer > span')
      textactula.forEach(z => {
        const Special = /[\\[{().+?|^&]/g
        if (z.innerHTML.includes(text)) {
          var textvalue = z.innerHTML
          if (Special.test(textvalue)) { textvalue = textvalue.replace(Special, '\\$&') }
          let regExp = new RegExp(text, 'gi')
          z.innerHTML = (z.textContent).replace(regExp, '<marker>$&</marker>')
        }
      })
    },
    refreshtoken () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN)
              this.salesPersonbitrix = res.data.NEW_TOKEN
            } else {
              console.log('something is wrong with refreshing the token')
              this.$router.push('/login')
            }
          },
          response => {
            console.log('something is wrong with refreshing the token')
            location.reload()
            this.$router.push('/login')
          }
        )
    },
    pagesRenderedHandler (pdfapp) {
      this.pdf = pdfapp
      this.activepage = pdfapp.page
      var thisvar = this
      this.pdf.bindEvents('pagechanging', (a) => {
        thisvar.page = a.page
      })
    }
    // scrolevent (pdfapp) {
    //   console.log('scroll', pdfapp)
    // },
    // openHandler (pdfapp) {
    //   this.pdf = pdfapp
    // },
    // whatpage (pdfapp) {
    //   console.log('whatpage', pdfapp)
    // },
    // currentpage (page) {
    //   console.log('page', page)
    // },
    // pageclick (pdfapp) {
    //   console.log('pdfappclick', pdfapp)
    // },
    // async openHandler2 (pdfApp) {
    //   this.info = []
    //   const info = await pdfApp.pdfDocument
    //     .getMetadata()
    //     .catch(console.error.bind(console))
    //   console.log('ifno', info)
    //   if (!info) return
    //   const props = Object.keys(info.info)
    //   props.forEach((prop) => {
    //     const obj = {
    //       name: prop,
    //       value: info.info[prop]
    //     }
    //     this.info.push(obj)
    //   })
    // }
  }
}
</script>
<style >
  
  #contract-main marker {
    background-color: aqua;
  }
  #contract-main .el-input__inner {
    -webkit-appearance: auto;
  }
  #contract-main .pointer {
    cursor: url(/cursor_1.png) 4 12, auto;
  }
  #contract-main .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .font12 {
    font-size: 12px;
  }
  .font14 {
    font-size: 14px;
  }
  #contract-main .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  #contract-main .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  #contract-main .el-textarea.is-disabled .el-textarea__inner {
      background-color: #ffffff;
      border-color: #dfe2e9;
      color: #7d8085;
      cursor: not-allowed;
  }
  #contract-main .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  #contract-main .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  .commentdiv {
      height: 900px;
      overflow: auto;
    }
  @media (max-width:27em) {
    .mm0 {
    margin: 0px;
    }
    .mmx-auto {
      margin-left: auto;
      -webkit-box-pack: center;
      justify-content: center;
    }
    .mmb5 {
      margin-bottom: 5rem;
    }
    .mpt1 {
      padding-top: .5rem;
    }
    .mobile-flex-column {
      flex-direction: column!important;
      align-items: center;
    }
    .xs-col-12 {
      width: 100%;
    }
    .mobile-100 {
      width: 100%!important;
    }
    .mp2 {
      padding: 1em;
    }
    .commentdiv {
      height: 750px;
      overflow:auto;
    }
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes pulse {
      0% {
        height: 1em;
        width:1em;
        margin-top: -0.5em;
        margin-left: -0.5em;
        opacity: 0.2;
      }
      50% {
        opacity: 0.9;
        height: 3em;
        width: 3em;
        margin-top: -1.5em;
        margin-left: -1.5em;
      }
      100% {
        opacity: 0.2;
        height: 1em;
        width: 1em;
        margin-top: -0.5em;
        margin-left: -0.5em;
      }
  }
</style>


// WEBPACK FOOTER //
// contract-mainv2.vue?d9c2e4ee